import React from "react";
import { TicketStatusNameType } from "../views/HomeView/HomeView";
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import EventIcon from '@mui/icons-material/Event';

export const getStatusIcon = (status: TicketStatusNameType) => {
    /* 
      'citation received (Approving)',
      'case accepted (Approved)',
      'letter of representation sent (Active)',
      'court respond by date satisfied (Pending)',
      'New court date',
      'negotiating with prosecutor',
      'offer received',
      'waiting for client to reject or accept offer',
      'waiting for judge to approve',
      'case closed/dismissed (closed)'
    */
    switch (status) {
      // case 'active':
      //   return <InfoIcon />;
      case 'citation received (Approving)':
        return <PendingIcon />;
      // case 'resolved':
      //   return <CheckCircleIcon />;
      case 'case closed/dismissed (closed)':
        return <ErrorIcon />;
      case 'waiting for client to reject or accept offer':
        return <PendingIcon />;
      default:
        return <InfoIcon />;
    }
  };